const EN = {
    modal: {
        title: 'Upload file',
    },
    uploader: {
        title: 'Registers',
        selectOrDrag: 'Select or drag the file',
        subtitle: '.txt, size less than 100MB',
        button: 'Select file',
        error: 'The file could not be processed',
    },
    states: {
        loading: 'Uploading...',
        success: 'The file was processed \n successfully',
        error: 'The file \n could not be processed',
        warning: 'Only ".txt" files are allowed \n and size must not exceed 100 MB'
    },
    buttonMessage: {
        sircupaButtonMessage: 'Upload registry'
    }
};

export default EN;
